module.exports = __webpack_public_path__ + "img/NTUA_LOGO.14d6d849.svg";